import { apiService } from 'libs/axios/services';
import { BaseService } from 'components/base/base-service';

export abstract class IInstallationTaskService extends BaseService<
    InstallationTable,
    IInstallationTaskUpdateReq,
    IInstallationTaskUpdateReq
> {}

export class InstallationTaskService extends IInstallationTaskService {
    path = '/installation-task';
    notFoundMessage = 'Installation task not found';

    getAll(
        request: InstallationListRequestJson,
    ): Promise<ApiResponse<ResponseBase<InstallationTable[]>>> {
        return apiService.get<InstallationListRequestJson, ResponseBase<InstallationTable[]>>(
            `${this.path}/list`,
            request,
            undefined,
            true,
        );
    }
    getById(_id: string): Promise<any> {
        return apiService.get<string, any>(`${this.path}/${_id}`);
    }

    update(_id: string, request: IInstallationTaskUpdateReq): Promise<any> {
        return apiService.put<IInstallationTaskUpdateReq, any>(
            `${this.path}/${_id}`,
            request,
            undefined,
            true,
        );
    }
    create(request: IInstallationTaskUpdateReq): Promise<any> {
        return apiService.post<IInstallationTaskUpdateReq, any>(`${this.path}/`, request);
    }
    deleteAll(_ids: string[]): Promise<any> {
        return apiService.delete<IExportTaskDeleteRequest, any>(
            `${this.path}/list`,
            undefined,
            undefined,
            {
                headers: { 'Content-Type': 'application/json' },
                data: { task_ids: _ids },
            },
            true,
        );
    }
    deleteById(_id: string): Promise<void> {
        throw new Error('Method not implemented.');
    }
    downloadCSV(_params?: URLSearchParams): Promise<ApiResponse<any>> {
        throw new Error('Method not implemented.');
    }
}
